<template>
  <b-modal id="delete-page-modal" class="confirm-dialog" hide-header centered>
    <p class="modal-main-message">Are you sure you want delete the page?</p>
    <p class="modal-secondary-message">
      All of the questions under it will be deleted.
    </p>
    <div slot="modal-footer">
      <b-btn
        @disabled="isLoading"
        variant="ghost"
        class="mr-1 btn-cancel"
        @click="$root.$emit('bv::hide::modal', 'delete-page-modal')"
      >
        Cancel
      </b-btn>
      <b-btn
        v-bind:disabled="isLoading"
        variant="primary"
        class="ml-1"
        @click="onDelete"
      >
        <template v-if="isLoading"> Deleting... </template>
        <template v-else>Confirm</template>
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "DeletePageModal",
  props: ["pageId"],
  methods: {
    ...mapActions("surveys", ["deletePage"]),
    onDelete() {
      this.deletePage({
        pageId: this.pageId,
        surveyId: this.$route.params.uuid
      });
      this.$root.$emit("bv::hide::modal", "delete-page-modal");
    },
  },
  computed: {
    ...mapState("surveys", ["isLoading"]),
  },
};
</script>

<style>
</style>